import { Component, Input } from '@angular/core';
import { IMenuItem } from '@app/shared/common/match/match-submenu/type';
import SvgIconComponent from '@app/shared/svg-icon/svg-icon.component';
import AppComponentBase from '@shared/common/app-component-base';
import UtilsModule from '@shared/utils/utils.module';
import { isNil } from 'lodash';

@Component({
    selector: 'app-match-submenu',
    imports: [UtilsModule, SvgIconComponent],
    templateUrl: './match-submenu.component.html',
    styleUrls: ['./match-submenu.component.less'],
})
class MatchSubmenuComponent extends AppComponentBase {
    @Input() menuItems: IMenuItem[] = [];

    showItem(item: IMenuItem): boolean {
        return isNil(item.permissions)
            ? true
            : this.isGrantedAny(...item.permissions);
    }
}

export default MatchSubmenuComponent;
